import { type ReactNode, useMemo } from 'react';
import { useAuth } from './AuthContext';

interface BrandContextValue {
  primaryColor: string;
  brandStyle: React.CSSProperties;
}

export function useBrand(): BrandContextValue {
  const { user } = useAuth();

  return useMemo(() => {
    const primaryColor = user?.schoolBrand?.primary_color || 'var(--primary-color)';
    return {
      primaryColor,
      brandStyle: {
        '--primary-color': primaryColor,
      } as React.CSSProperties,
    };
  }, [user]);
}

export function BrandInjector({ children }: { children: ReactNode }) {
  const { brandStyle } = useBrand();
  return <div style={brandStyle}>{children}</div>;
}
